export function zendeskChatConfig() {
  sessionStorage.setItem("zendeskAccountId", process.env.REACT_APP_ZENDESK_ACCOUNT_ID ?? "");
  sessionStorage.setItem("zendeskDepartmentId", process.env.REACT_APP_ZENDESK_DEPARTMENT_ID ?? "");
  const zopimInit = new Event("zopimInit");
  document.dispatchEvent(zopimInit);
}
